<template>
  <div>
    <v-contextmenu ref="contextmenu">
      <v-contextmenu-item @click="handelDetail">查看详情</v-contextmenu-item>
      <v-contextmenu-submenu title="创建任务">
        <v-contextmenu-item
          v-for="(item, index) in taskTypeList"
          @click="handelCreateTask(item)"
          :key="index"
        >{{item.NAME }}</v-contextmenu-item>
      </v-contextmenu-submenu>
      <v-contextmenu-item @click="setTag">设置标签</v-contextmenu-item>
      <v-contextmenu-item @click="commentRecord">评论</v-contextmenu-item>
      <v-contextmenu-item v-clipboard:copy="shareUrl" @click.native="shareRecord">分享</v-contextmenu-item>
    </v-contextmenu>
    <el-dialog title="工作记录评论" append-to-body :visible.sync="recordDialogVisible" width="60%">
      <comment
        :MainId="recordId"
        ref="comment"
        :Type="'1'"
        @addCommentSuccess="refershComment(true)"
        @delCommentSuccess="refershComment(false)"
        @cancelSuccess="cancelSuccess"
      ></comment>
    </el-dialog>
    <TagSelect ref="tagSelect" :tagIds="tagIds" :showFootButton="true" @success="saveTag"></TagSelect>
    <CreateTask ref="CreateTask" :RelationRecordId="contextMenu.ID" @getValue="Success"></CreateTask>
    <CreateTaskForm ref="CreateTaskForm" @success="Success"></CreateTaskForm>
  </div>
</template>
<script>
import {
  SaveTaskTags,
  GetRecordRelationByRecordId,
} from "@/api/modules/basicData/task";
import TagSelect from "../common/Tag/TagSelect";
export default {
  components: {
    TagSelect,
    comment: () => import("@/components/common/comment.vue"),
    CreateTask: () => import("./CreateTask.vue"),
  },
  props: {
    contextMenu: {
      type: Object,
      default: () => {},
      require: true,
    },

    isTask: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    contextMenu(newValue) {
      if (newValue) {
        this.shareUrl = `${location.href.substr(
          0,
          location.href.lastIndexOf("/")
        )}/recordinfo?recordid=${newValue.ID}`;
      }
    },
  },
  data() {
    return {
      shareUrl: "",
      recordId: "",
      recordDialogVisible: false,
      taskTypeList: JSON.parse(localStorage.getItem("TaskType")),
    };
  },
  computed: {
    tagIds() {
      return this.contextMenu.Tags != undefined && this.contextMenu.Tags != null
        ? this.contextMenu.Tags.map((o) => o.TAGID)
        : [];
    },
  },
  methods: {
    //显示右键菜单
    Show(postition) {
      this.$refs.contextmenu.show(postition);
    },
    /**
     * 详情
     */
    handelDetail() {
      this.openBlank(this.contextMenu.ID);
    },
    /**
     * 打开详情
     */
    openBlank(id) {
      let routeUrl = this.$router.resolve({
        path: "/recordinfo",
        query: {
          recordid: id,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
    /**
     * 分享
     */
    shareRecord() {
      this.$message({
        message: "工作记录链接已复制,请粘贴到地址栏访问",
        type: "success",
      });
    },
    /**
     * 设置标签
     */
    setTag() {
      this.$refs.tagSelect.dialogVisible = true;
    },
    /**
     * 设置标签
     */
    saveTag(values) {
      var tags = values.map((value) => {
        return {
          TASKID: this.contextMenu.ID,
          TAGID: value.ID,
          COLOR: value.COLOR,
          TAGNAME: value.TAGNAME,
          CREATEUSERID: value.CREATEUSERID,
          CREATEUSERNAME: value.CREATEUSERNAME,
          CREATEDEPTID: value.CREATEDEPTID,
          CREATEDEPTNAME: value.CREATEDEPTNAME,
          CREATECOMPANYID: value.CREATECOMPANYID,
          CREATECOMPANYNAME: value.CREATECOMPANYNAME,
        };
      });
      SaveTaskTags(tags, this.contextMenu.ID).then((result) => {
        if (result.ResultCode > 0) {
          this.$emit("successed");
        } else {
          this.$message.error(result.MsgInfo);
        }
      });
    },
    /**
     * 评论
     */
    commentRecord() {
      this.recordId = this.contextMenu.ID;
      this.recordDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.comment.initialTask();
      });
    },
    refershComment() {},
    cancelSuccess() {
      this.recordDialogVisible = false;
    },
    /**
     * 创建任务
     */
    saveTaskSuccess(task) {
      GetRecordRelationByRecordId(this.contextMenu.ID).then((result) => {
        if (result) {
          this.contextMenu.Relations = result;
        }
      });
    },
    handelCreateTask(item) {
      if (item.FORMID) {
        this.$refs.CreateTaskForm.openDialog(item, 0);
      } else {
        this.$refs.CreateTask.OpenDialog(item, 0);
      }
    },
    Success(row) {
      this.saveTaskSuccess(row);
    },
  },
};
</script>